import React from 'react';
import PropTypes from 'prop-types';
import { useGuideConfig } from '@ignitesales/neuro-application';
import ToggleMenu from '@ignitesales/neuro-application/src/neuro-ui/lib/ToggleMenu';
import LayoutRenderer from '@ignitesales/neuro-application/src/neuro-guide/components/QuestionGroups/layouts/LayoutRenderer';
import IntegrationForm from './IntegrationForm';

const ActionSlidePanel = ({ action, isOpen, onClose, context = {} }) => {
  const { layouts } = useGuideConfig();
  const { targetType } = action || {};

  // Check if the layout is a slide layout
  const layout = targetType === 'layout' && action?.layoutId && layouts ?
    layouts.find(l => String(l.id) === String(action.layoutId)) : null;

  const isSlideLayout = layout?.layoutType === 'slide';
  const width = layout?.width || '400px';

  const renderContent = () => {
    if (targetType === 'integration') {
      return <IntegrationForm action={action} context={context} onClose={onClose} />;
    } else if (targetType === 'layout') {
      return <LayoutRenderer action={action} context={context} />;
    }
    return null;
  };

  const [delayedIsOpen, setDelayedIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (isOpen) {
      // Small delay to ensure the component is mounted before animating in
      const timer = setTimeout(() => setDelayedIsOpen(true), 50);
      return () => clearTimeout(timer);
    } else {
      setDelayedIsOpen(false);
    }
  }, [isOpen]);

  return (
    <ToggleMenu
      className={`action-slide-panel ${isSlideLayout ? 'action-slide-panel--layout' : ''}`}
      animation="slideFromRight"
      isOpen={delayedIsOpen}
      onOuterClick={onClose}
      style={{ width: width, maxWidth: width, minWidth: width, zIndex: 1000 }}
    >
      {!isSlideLayout && (
        <i
          className="fa fa-times action-slide-panel__closeBtn"
          onClick={onClose}
        />
      )}
      <div className="action-slide-panel__content" style={{ width: width }}>
        {renderContent()}
      </div>
    </ToggleMenu>
  );
};

ActionSlidePanel.propTypes = {
  action: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  context: PropTypes.object
};

export default ActionSlidePanel;



